
// Cart Savings Banner Controller
async function updateCartBanner() {
  const banner = document.querySelector('.nr-cart-banner');
  if (!banner) return;
  
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    if (cart.item_count === 0) {
      banner.style.opacity = '0';
      setTimeout(() => banner.style.display = 'none', 300);
      return;
    }
    
    // Check for discount codes
    let hasSavings = cart.total_discount > 0;
    
    // If no discount code, check for compare_at_price savings
    if (!hasSavings) {
      for (const item of cart.items) {
        try {
          const productResponse = await fetch(`/products/${item.handle}.js`);
          const product = await productResponse.json();
          const variant = product.variants.find(v => v.id === item.variant_id);
          
          if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
            hasSavings = true;
            break; // Found savings, no need to check more items
          }
        } catch (e) {
          // Skip if product fetch fails
        }
      }
    }
    
    if (hasSavings) {
      banner.style.display = 'block';
      setTimeout(() => banner.style.opacity = '1', 10);
    } else {
      banner.style.opacity = '0';
      setTimeout(() => banner.style.display = 'none', 300);
    }
  } catch (e) {
    // Hide on error
    banner.style.opacity = '0';
    setTimeout(() => banner.style.display = 'none', 300);
  }
}

// Run on load (drawer just opened)
updateCartBanner();

// Listen to cart events
['cart:updated', 'cart:refresh'].forEach(event => {
  document.addEventListener(event, updateCartBanner);
});

// Listen to theme's pubsub
if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe) {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, updateCartBanner);
}
